import { KameleoonExperiments, KameleoonVariants } from '@/hooks/kameleoon/kameleoonExperiments';
import { useExperimentBase } from '@/hooks/kameleoon/utils/useExperimentBase';

const useIsInScoutCategoriesOnCategoryPagesExperiment = () =>
    useExperimentBase(
        KameleoonExperiments.ScoutCategoriesOnCategoryPages,
        KameleoonVariants.ScoutCategoriesOnCategoryPages.Variant
    );

const useScoutCategoriesOnCategoryPagesControl = () =>
    useExperimentBase(
        KameleoonExperiments.ScoutCategoriesOnCategoryPages,
        KameleoonVariants.ScoutCategoriesOnCategoryPages.Control
    );

const useIsNotInScoutCategoriesOnCategoryPagesExperiment = () =>
    useExperimentBase(
        KameleoonExperiments.ScoutCategoriesOnCategoryPages,
        KameleoonVariants.ScoutCategoriesOnCategoryPages.Off
    );

export const useScoutCategoriesOnCategoryPagesExperiment = () => {
    const hasScoutCategoriesOnCategoryPagesVariant = useIsInScoutCategoriesOnCategoryPagesExperiment();
    useScoutCategoriesOnCategoryPagesControl();
    useIsNotInScoutCategoriesOnCategoryPagesExperiment();
    return hasScoutCategoriesOnCategoryPagesVariant;
};
